/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

/**
 * Custom alert component to replace UI Bootstrap's uib-alert
 * Supports different alert types and optional dismissible behavior
 */
@Component({
  selector: 'ut-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertComponent {
  /**
   * Alert type: 'success', 'info', 'warning', or 'danger'
   */
  @Input() type: 'success' | 'info' | 'warning' | 'danger' = 'info';

  /**
   * Whether the alert can be dismissed
   */
  @Input() dismissible: boolean = false;

  /**
   * Event emitted when the alert is closed
   */
  @Output() close = new EventEmitter<void>();

  /**
   * Flag to track if alert has been dismissed
   */
  dismissed = false;

  /**
   * Get the CSS class for the alert type
   */
  get alertClass(): string {
    return `alert-${this.type}`;
  }

  /**
   * Handle close button click
   */
  onClose(): void {
    this.dismissed = true;
    this.close.emit();
  }
}
